import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  effect,
  input,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Guid, isNotEmptyArray } from '@web/utils';
import { Observable } from 'rxjs';
import { AdminShippingMethodDetails } from '../../models/admin-shipping-method-details';
import { AdminShippingMethodDataSourceService } from '../../services/admin-shipping-method-data-source.service';
import {
  CurrencyComponent,
  DateTimeComponent,
  DetailsViewComponent,
  NoDataComponent,
  SpinnerFilledComponent,
} from '@web/shared/ui';
import { AdminShippingMethodPrice } from '../../models/admin-shipping-method-price';
import {
  Accordion,
  AccordionContent,
  AccordionHeader,
  AccordionPanel,
} from 'primeng/accordion';
import { SummernoteHtmlPreviewComponent } from '@web/shared/external';

@Component({
  selector: 'app-admin-shipping-method-details',
  imports: [
    CommonModule,
    DetailsViewComponent,
    DateTimeComponent,
    SpinnerFilledComponent,
    NoDataComponent,
    CurrencyComponent,
    Accordion,
    AccordionPanel,
    AccordionHeader,
    AccordionContent,
    SummernoteHtmlPreviewComponent,
  ],
  templateUrl: './admin-shipping-method-details.component.html',
  styleUrl: './admin-shipping-method-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminShippingMethodDetailsComponent {
  /* prettier-ignore */
  private readonly shippingMethodDataSource = inject(AdminShippingMethodDataSourceService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  public readonly id = input.required<Guid>();

  protected data$!: Observable<AdminShippingMethodDetails>;

  public constructor() {
    effect(() => this.configureDataSource());
  }

  protected shouldShowPrices(
    attributes: AdminShippingMethodPrice[],
  ): attributes is AdminShippingMethodPrice[] {
    return isNotEmptyArray(attributes);
  }

  private configureDataSource(): void {
    this.data$ = this.shippingMethodDataSource.fetchDetailsById(this.id());

    this.changeDetectorRef.detectChanges();
  }
}
